module.exports = __webpack_public_path__ + "assets-cabinet/img/world-sphere-icon.80972a26.svg";